import { takeLatest, put, call, select } from 'redux-saga/effects';
import { GET_BOOKING_SAGA } from "../sagaTypes";
import { loadingAction } from '../actions.js';
import { url } from "../../config";
import { toast } from 'react-hot-toast';
import { bookingAction } from "../actions";
import { setScheduleActiveAction } from "../actions";

const request = data => {
    return fetch(`${ url }/get_booking`, {
        method: 'post',
        body: data
    })
        .then(response => response.json()).catch(error => console.log(error))
};

function* workerGetBooking(args) {
    const est = yield select(state => state.est);
    const user = yield select(state => state.user);

    yield put(loadingAction(true));
    const filters = yield select(state => state.filters);

    try {
        let formData = new FormData();
        formData.append('user_id', user.id);
        formData.append('date', args.data?.date || '');
        formData.append('coaches', JSON.stringify(filters.coaches?.filter(el => el.active)?.map(el => el.id)));
        formData.append('types', JSON.stringify(filters.types?.filter(el => el.active)?.map(el => el.id)));

        if (est.slug && est.id) {
            formData.append('slug', est.slug);
            formData.append('est', est.id);
        }

        const response = yield call (request, formData);

        if (response.success) {
            yield put(bookingAction(response.booking));
            yield put(setScheduleActiveAction(response.schedule_active));
        }
        else if (response.error) {
            toast.error(response.message);
        }
    }
    catch(error) {
        console.log(error);
        yield put(loadingAction(false));
    }
    finally {
        yield put(loadingAction(false));
    }
}

export default function* watcherGetBooking() {
    yield takeLatest(GET_BOOKING_SAGA, workerGetBooking);
}